exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copy-btn[data-v-b4b757c0]{background:#d12e4f;color:#fff}.copy-btn[data-v-b4b757c0]:hover{opacity:.7}", ""]);

// exports
